import React, { FunctionComponent } from 'react';
import { LinkProps } from 'components/link/link';
import { P2, TextColor } from 'components/typography';

export type FooterLinksItemProps = LinkProps & {
    text: string;
    url?: string;
    extraClasses?: string;
};

export type FooterLinksProps = {
    items: FooterLinksItemProps[];
};

const FooterLinks: FunctionComponent<FooterLinksProps> = (props) => {
    const { items } = props;

    return (
        <div className="footer-links">
            {items.map((item: FooterLinksItemProps, key) =>
                item.text ? (
                    <div className="footer-links__item" key={`footer-links-item-${key}`}>
                        <P2 color={TextColor.BLACK}>
                            <a
                                className={`footer-links__link ${item.extraClasses || ''}`}
                                href={item.url}
                                target={item.target}
                            >
                                {item.text}
                            </a>
                        </P2>
                    </div>
                ) : undefined
            )}
        </div>
    );
};

export default FooterLinks;
